import { render, staticRenderFns } from "./OrderStatusChip.vue?vue&type=template&id=351e0b5b"
import script from "./OrderStatusChip.vue?vue&type=script&lang=js"
export * from "./OrderStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports